import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'palantir-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PalantirToolbarComponent {}
